import { useState } from 'react';

import { ApiError, api } from '../../lib/api.js';
import { signInUrl, type SiteUser } from './WebsiteApp.js';

/**
 * Approving the Prism desktop app: the app shows a code and opens this page;
 * approving lets that app publish games to this account's library.
 */
export function LinkPage({ user, ready }: { user: SiteUser | null; ready: boolean }) {
  const code = new URLSearchParams(window.location.search).get('code')?.toUpperCase() ?? '';
  const [state, setState] = useState<'idle' | 'busy' | 'done'>('idle');
  const [error, setError] = useState<string | null>(null);

  if (!ready) return null;
  return (
    <div className="site-page link-page">
      <div className="site-card">
        <h1>Connect the Prism Engine Cloud desktop app</h1>
        {!code ? (
          <p className="muted">Open this page from the desktop app's "Publish to Prism Engine Cloud Library" button.</p>
        ) : !user ? (
          <>
            <p>Sign in to let the desktop app publish games to your account.</p>
            <a className="primary button-link" href={signInUrl()}>
              Sign in with Google
            </a>
          </>
        ) : state === 'done' ? (
          <p>Done. Go back to the desktop app: it can publish to your library now.</p>
        ) : (
          <>
            <p>Check that the desktop app shows this code:</p>
            <p className="link-code">{code}</p>
            <p className="muted">Approving lets that app publish and update games in your library as {user.email}. Only approve a code you started yourself.</p>
            <button
              className="primary"
              type="button"
              disabled={state === 'busy'}
              onClick={async () => {
                setState('busy');
                setError(null);
                try {
                  await api.post('/link/approve', { code, label: 'Prism Engine Cloud desktop' });
                  setState('done');
                } catch (e) {
                  setError(e instanceof ApiError ? e.message : 'Could not approve the code.');
                  setState('idle');
                }
              }}
            >
              Approve
            </button>
          </>
        )}
        {error && (
          <p className="login-error" role="alert">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}
